export const ENV = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000',
  ENV: process.env.NODE_ENV || 'development',
  IS_PROD: process.env.NODE_ENV === 'production'
} 